import { render } from "./index.vue?vue&type=template&id=74c462b0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=74c462b0&scoped=true&lang=css"

import exportComponent from "D:\\php\\php20260824_dianshang\\mall-son_dxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c462b0"]])

export default __exports__